import React from 'react';
import { companyInfo } from '../data/mock';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-[#D4AF37]/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" className="flex items-center">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-14 w-auto object-contain"
            />
          </a>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="#servicios"
              className="text-white/80 hover:text-[#D4AF37] text-sm font-medium transition-colors duration-300"
            >
              Servicios
            </a>
            <a
              href="#equipo"
              className="text-white/80 hover:text-[#D4AF37] text-sm font-medium transition-colors duration-300"
            >
              Nuestro Equipo
            </a>
            <a
              href="#contacto"
              className="text-white/80 hover:text-[#D4AF37] text-sm font-medium transition-colors duration-300"
            >
              Contacto
            </a>
          </nav>

          {/* Phone CTA */}
          <a
            href={companyInfo.telLink1}
            className="hidden sm:flex items-center gap-2 text-[#D4AF37] hover:text-[#E8C554] text-sm font-medium transition-colors duration-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            {companyInfo.phone1}
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
